const states = [
    {
        id: 'new',
        description: "Pendent"
    },
    {
        id: 'draft',
        description: "Pendent"
    },
    {
        id: 'active',
        description: "Publicada"
    },
    {
        id: 'deleted',
        description: "Esborrada"
    }
]

export { states }


// WEBPACK FOOTER //
// ./src/services/state.service.js